import ListTheoryTaskDetails from './list-theory-task-details'

export default ListTheoryTaskDetails
